import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/Layout"
import SEO from "../components/SEO"
import ReactMarkdown from "react-markdown"

const ComponentName = ({data}) => {
  const {content,title,description} = data?.blog
  console.log(data,"This is blog data")
  return <Layout>
    <SEO title={title} description={description}/>
    <section className='blog-template'>
      <div className='section-center'>
        <article className='blog-content'>
          <ReactMarkdown source={content}/>
        </article>
        <Link to='/blog' className='btn center-btn'>blog</Link>
      </div>
      </section>
  </Layout>
}

export const query = graphql`
  query GetSingleBlog($slug: String) {
    blog: strapiBlogs(slug: { eq: $slug }) {
      content
      title
      description
    }
  }
`

export default ComponentName
